import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { FormFieldText } from '.';
import { RichTextDisplay } from './RichTextDisplay';

interface Props {
  value?: string;
  previousValue?: string | null;
  onClose: () => void;
  config: FormFieldText;
}

export const RichTextDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const prevZeroState = !previousValue;
  const currentZeroState = !value;
  const label = config.params.labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No data available
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? zeroState : <RichTextDisplay value={previousValue} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? zeroState : <RichTextDisplay value={value} />}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
